var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { showTab: _vm.isShowTab } },
    [
      _c("div", { staticClass: "main-content-wrap" }, [
        _c("div", { ref: "anchor-0", staticClass: "title anchor-item" }, [
          _vm._v("主要信息"),
        ]),
        _c("div", { staticClass: "content-h" }, [
          _c("div", { staticClass: "content-h-l" }, [
            _c("div", { staticClass: "content-h-l-img" }, [
              _vm.detail.image
                ? _c("img", {
                    staticClass: "pic",
                    staticStyle: {
                      width: "84px",
                      height: "84px",
                      "border-radius": "4px 4px 4px 4px",
                    },
                    attrs: { src: _vm.detail.image },
                  })
                : _vm._e(),
              !_vm.detail.image
                ? _c("img", {
                    staticStyle: {
                      width: "84px",
                      height: "84px",
                      "border-radius": "4px 4px 4px 4px",
                    },
                    attrs: { src: require("@/assets/def_avatar_84px.png") },
                  })
                : _vm._e(),
            ]),
            _c("div", { staticClass: "content-h-l-c" }, [
              _c("div", { staticStyle: { display: "flex" } }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(_vm.detail.reallyName || "--")),
                ]),
                _vm.detail.sex == "1"
                  ? _c("div", { staticClass: "sex-m" })
                  : _vm.detail.sex == "2"
                  ? _c("div", { staticClass: "sex-w" })
                  : _vm._e(),
                _vm.detail.statusLabel == "已转正"
                  ? _c("div", { staticClass: "status" }, [
                      _vm._v(_vm._s(_vm.detail.statusLabel)),
                    ])
                  : _vm.detail.statusLabel == "待离职"
                  ? _c("div", { staticClass: "status1" }, [
                      _vm._v(_vm._s(_vm.detail.statusLabel)),
                    ])
                  : _vm.detail.statusLabel == "试用"
                  ? _c("div", { staticClass: "status2" }, [
                      _vm._v(_vm._s(_vm.detail.statusLabel)),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-wrap": "wrap",
                    "margin-top": "20px",
                  },
                },
                [
                  _c("div", { staticClass: "text" }, [
                    _vm._v("员工工号：" + _vm._s(_vm.detail.serial || "--")),
                  ]),
                  _c("div", { staticClass: "text" }, [
                    _vm._v("职位：" + _vm._s(_vm.detail.positionName || "--")),
                  ]),
                  _c("div", { staticClass: "text" }, [
                    _vm._v("所属部门：" + _vm._s(_vm.detail.orgName || "--")),
                  ]),
                ]
              ),
            ]),
          ]),
          _c("div", { staticClass: "content-h-r" }, [
            _c("div", { staticClass: "time" }, [_vm._v("创建日期：")]),
            _c("div", { staticClass: "time" }, [
              _vm._v(
                _vm._s(
                  _vm.detail.createdTimeFormat || _vm.detail.createdTime || "--"
                )
              ),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "content-c" },
          [
            _c(
              "el-form",
              {
                staticClass: "l-form",
                attrs: { inline: true, size: "small", "label-width": "92px" },
              },
              [
                _c("el-form-item", { attrs: { label: "入职日期：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.employeeDate || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "直属上级：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.directSuperior || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "聘用形式：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.jobNatureLabel || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "工作手机号：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.workPhone || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "登录手机号：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.phoneNumber || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "手机号1：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.extraPhoneFirst || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "手机号2：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.extraPhoneSecond || "--")),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "钉钉登录手机号：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("钉钉登录   "),
                              _c("br"),
                              _vm._v("手机号："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.dingPhone || "--")),
                    ]),
                  ]
                ),
                _c("el-form-item", { attrs: { label: "转正日期：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.confirmationDate || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "离职日期：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.leaveTime || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "更新日期：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(
                      _vm._s(
                        _vm.detail.updatedTimeFormat ||
                          _vm.detail.updatedTime ||
                          "--"
                      )
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "split-line" }),
        _c("div", { ref: "anchor-1", staticClass: "title anchor-item" }, [
          _vm._v("基础信息"),
        ]),
        _c(
          "div",
          { staticClass: "content-c" },
          [
            _c(
              "el-form",
              {
                staticClass: "l-form",
                attrs: { inline: true, size: "small", "label-width": "92px" },
              },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "招聘信息来源：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("招聘信息   "),
                              _c("br"),
                              _vm._v("来源："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.recruitOriginLabel || "--")),
                    ]),
                  ]
                ),
                _c("el-form-item", { attrs: { label: "身份证号码：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.idCardNumber || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "出生日期：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.dateOfBirth || "--")),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "属相：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _vm._v(" 属"),
                            _c("span", { staticClass: "space" }),
                            _vm._v("相： "),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.zodiacLabel || "--")),
                    ]),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "民族：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _vm._v(" 民"),
                            _c("span", { staticClass: "space" }),
                            _vm._v("族： "),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.nation || "--")),
                    ]),
                  ]
                ),
                _c("el-form-item", { attrs: { label: "最高学历：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.educationalLevelLabel || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "婚姻状况：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.maritalStatusLabel || "--")),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "汽(机)车驾照：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("汽(机)车   "),
                              _c("br"),
                              _vm._v("驾照："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(
                        _vm._s(_vm.detail.drivingLicenseLevelLabel || "--")
                      ),
                    ]),
                  ]
                ),
                _c("el-form-item", { attrs: { label: "微信号：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.wechatNumber || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "邮箱地址：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.email || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "爱好/专长：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.hobby || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "身高(cm)：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.height || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "体重(kg)：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.weight || "--")),
                  ]),
                ]),
                _c("el-form-item", { attrs: { label: "政治面貌：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(
                      _vm._s(_vm.detail.politicalAffiliationLabel || "--")
                    ),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "籍贯：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _vm._v("籍"),
                            _c("span", { staticClass: "space" }),
                            _vm._v("贯"),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.nativePlace || "--")),
                    ]),
                  ]
                ),
                _c("el-form-item", { attrs: { label: "户口性质：" } }, [
                  _c("div", { staticClass: "text-f" }, [
                    _vm._v(_vm._s(_vm.detail.householdTypeLabel || "--")),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "身份证详细地址：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("身份证   "),
                              _c("br"),
                              _vm._v("详细地址："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(
                        _vm._s(_vm.detail.householdResidenceDetail || "--") +
                          " "
                      ),
                    ]),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "居住地详细地址：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("居住地   "),
                              _c("br"),
                              _vm._v("详细地址："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.currentResidenceDetail || "--")),
                    ]),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "紧急联系人姓名：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("紧急联系人   "),
                              _c("br"),
                              _vm._v("姓名："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.emergencyContactName || "--")),
                    ]),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "two-label",
                    attrs: { label: "紧急联系人电话：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("紧急联系人   "),
                              _c("br"),
                              _vm._v("电话："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-f" }, [
                      _vm._v(_vm._s(_vm.detail.emergencyContactPhone || "--")),
                    ]),
                  ]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "原单位是否存在纠纷：" },
                    scopedSlots: _vm._u([
                      {
                        key: "label",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "custom-label" }, [
                              _vm._v("原单位是否   "),
                              _c("br"),
                              _vm._v("存在纠纷："),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("div", { staticClass: "text-dispute" }, [
                      _c("div", { staticClass: "text-f dispute-flag" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              (_vm.detail.disputeFlag == 1 ? "是" : "否") ||
                                "--"
                            ) +
                            " "
                        ),
                      ]),
                      _vm.detail.dispute
                        ? _c("div", { staticClass: "dispute-info" }, [
                            _vm._v(_vm._s(_vm.detail.dispute)),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "relative" },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "l-form",
                    attrs: {
                      inline: true,
                      size: "small",
                      "label-width": "92px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "margin-right": "-6px" },
                        attrs: {
                          label: "是否有亲戚/朋友在公司：",
                          "label-width": "98px",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "custom-label" }, [
                                  _vm._v("是否有亲戚/  "),
                                  _c("br"),
                                  _vm._v("朋友在公司："),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                      },
                      [
                        _c("div", { staticClass: "text-f" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.detail.kinFlag == 1 ? "是" : "否" || "--"
                              ) +
                              " "
                          ),
                        ]),
                      ]
                    ),
                    _vm.detail.kinFlag == 1
                      ? [
                          _c("el-form-item", { attrs: { label: "其姓名：" } }, [
                            _c("div", { staticClass: "text-f" }, [
                              _vm._v(_vm._s(_vm.detail.kinName || "--")),
                            ]),
                          ]),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "关系：" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v("关"),
                                        _c("span", { staticClass: "space" }),
                                        _vm._v("系："),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3504602226
                              ),
                            },
                            [
                              _c("div", { staticClass: "text-f" }, [
                                _vm._v(
                                  _vm._s(_vm.detail.kinRelationship || "--")
                                ),
                              ]),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "部门：" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v("部"),
                                        _c("span", { staticClass: "space" }),
                                        _vm._v("门："),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                802832986
                              ),
                            },
                            [
                              _c("div", { staticClass: "text-f" }, [
                                _vm._v(
                                  _vm._s(_vm.detail.kinOrganization || "--")
                                ),
                              ]),
                            ]
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "split-line" }),
        _c("div", { ref: "anchor-2", staticClass: "title anchor-item" }, [
          _vm._v("工作履历"),
          _c(
            "span",
            {
              staticStyle: {
                "font-weight": "400",
                "font-size": "16px",
                color: "#616363",
              },
            },
            [_vm._v("（时间由近至远）")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "content-c" },
          _vm._l(_vm.detail.workRecordList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", { staticClass: "sort-index" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c("div", { staticClass: "sort-title" }, [
                      _vm._v("工作履历"),
                    ]),
                  ]
                ),
                _c(
                  "el-form",
                  {
                    staticClass: "l-form",
                    staticStyle: { "margin-top": "24px" },
                    attrs: {
                      inline: true,
                      size: "small",
                      "label-width": "92px",
                    },
                  },
                  [
                    _c("el-form-item", { attrs: { label: "起始日期：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.startTime || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "结束日期：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.endTime || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "单位名称：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.company || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "任职部门：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.organization || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "担任职位：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.post || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "现离职原因：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.resignationReasonLabel || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "工作收入：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.salary || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "证明人：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.certifier || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "联系电话：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.phone || "--")),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "split-line" }),
        _c("div", { ref: "anchor-3", staticClass: "title anchor-item" }, [
          _vm._v("教育经历"),
          _c(
            "span",
            {
              staticStyle: {
                "font-weight": "400",
                "font-size": "16px",
                color: "#616363",
              },
            },
            [_vm._v("（学历由高至低）")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "content-c" },
          _vm._l(_vm.detail.educationList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", { staticClass: "sort-index" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c("div", { staticClass: "sort-title" }, [
                      _vm._v("教育经历"),
                    ]),
                  ]
                ),
                _c(
                  "el-form",
                  {
                    staticClass: "l-form",
                    staticStyle: { "margin-top": "24px" },
                    attrs: {
                      inline: true,
                      size: "small",
                      "label-width": "92px",
                    },
                  },
                  [
                    _c("el-form-item", { attrs: { label: "起始日期：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.startTime || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "结束日期：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.endTime || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "学校名称：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.institutionName || "--")),
                      ]),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "专业：" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v("专"),
                                  _c("span", { staticClass: "space" }),
                                  _vm._v("业："),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("div", { staticClass: "text-f" }, [
                          _vm._v(_vm._s(item.major || "--")),
                        ]),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "学历：" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v("学"),
                                  _c("span", { staticClass: "space" }),
                                  _vm._v("历："),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("div", { staticClass: "text-f" }, [
                          _vm._v(_vm._s(item.educationalLevelLabel || "--")),
                        ]),
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: "教育类型：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.educationalModeLabel || "--")),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "split-line" }),
        _c("div", { ref: "anchor-4", staticClass: "title anchor-item" }, [
          _vm._v("家庭信息 "),
        ]),
        _c(
          "div",
          { staticClass: "content-c" },
          _vm._l(_vm.detail.familyInfoList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", { staticClass: "sort-index" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c("div", { staticClass: "sort-title" }, [
                      _vm._v("家庭成员"),
                    ]),
                  ]
                ),
                _c(
                  "el-form",
                  {
                    staticClass: "l-form",
                    staticStyle: { "margin-top": "24px" },
                    attrs: {
                      inline: true,
                      size: "small",
                      "label-width": "92px",
                    },
                  },
                  [
                    _c("el-form-item", { attrs: { label: "本人关系：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.familyRelationshipsLabel || "--")),
                      ]),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "姓名：" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v("姓"),
                                  _c("span", { staticClass: "space" }),
                                  _vm._v("名："),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("div", { staticClass: "text-f" }, [
                          _vm._v(_vm._s(item.name || "--")),
                        ]),
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: "工作单位：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.company || "--")),
                      ]),
                    ]),
                    _c(
                      "el-form-item",
                      {
                        attrs: { label: "职务：" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function () {
                                return [
                                  _vm._v("职"),
                                  _c("span", { staticClass: "space" }),
                                  _vm._v("务："),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("div", { staticClass: "text-f" }, [
                          _vm._v(_vm._s(item.post || "--")),
                        ]),
                      ]
                    ),
                    _c("el-form-item", { attrs: { label: "联系电话：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.phone || "--")),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticClass: "split-line" }),
        _c("div", { ref: "anchor-5", staticClass: "title anchor-item" }, [
          _vm._v("培训经历"),
          _c(
            "span",
            {
              staticStyle: {
                "font-weight": "400",
                "font-size": "16px",
                color: "#616363",
              },
            },
            [_vm._v("（非必填项）")]
          ),
        ]),
        _c(
          "div",
          { staticClass: "content-c" },
          _vm._l(_vm.detail.trainingInfoList, function (item, index) {
            return _c(
              "div",
              { key: index },
              [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "flex-start",
                      "align-items": "center",
                    },
                  },
                  [
                    _c("div", { staticClass: "sort-index" }, [
                      _vm._v(_vm._s(index + 1)),
                    ]),
                    _c("div", { staticClass: "sort-title" }, [
                      _vm._v("培训经历"),
                    ]),
                  ]
                ),
                _c(
                  "el-form",
                  {
                    staticClass: "l-form",
                    staticStyle: { "margin-top": "24px" },
                    attrs: {
                      inline: true,
                      size: "small",
                      "label-width": "96px",
                    },
                  },
                  [
                    _c("el-form-item", { attrs: { label: "起始日期：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.startTime || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "结束日期：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.endTime || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "培训方式：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.trainingModeLabel || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "培训机构：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.institutionName || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "获取证书：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.certificate || "--")),
                      ]),
                    ]),
                    _c("el-form-item", { attrs: { label: "培训内容：" } }, [
                      _c("div", { staticClass: "text-f" }, [
                        _vm._v(_vm._s(item.trainingContent || "--")),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          0
        ),
        _c("div", { staticStyle: { height: "20px" } }),
      ]),
      _vm.isShowTab
        ? [
            _c("transition", { attrs: { name: "el-fade-in" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.footer,
                      expression: "footer",
                    },
                  ],
                  staticClass: "panel-right",
                },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "vertical-tabs",
                      staticStyle: { height: "auto" },
                      attrs: { "tab-position": "right" },
                      on: { "tab-click": _vm.handleClickAchors },
                      model: {
                        value: _vm.activeBtn,
                        callback: function ($$v) {
                          _vm.activeBtn = $$v
                        },
                        expression: "activeBtn",
                      },
                    },
                    _vm._l(_vm.anchors, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: { label: item.label, name: String(index) },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }